/* eslint-disable react-hooks/exhaustive-deps */
import {
  ArrowRightOutlined,
  PlusOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import {
  Alert,
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { CuttingType } from "../../models/CuttingType";
import "./calculation.module.scss";
import CadFileItem from "./CadFileItem";
import { Project } from "../../models/Project";
import { Part } from "../../models/Part";
import { useDispatch, useSelector } from "react-redux";
import {
  projectActions,
  projectSelector,
} from "../../redux/slides/project.slide";
import CalculationStep1 from "./CalculationStep1";
import dayjs from "dayjs";
import moment from "moment";
import projectServices from "../../services/project.service";
import { RangePickerProps } from "antd/es/date-picker";
import { useTranslation } from "react-i18next";
import { PartViewMode } from "../../models/PartViewMode";
import LoadingIcon from "../SVGs/LoadingIcon";
import { RcFile } from "antd/lib/upload/interface";
import Utils from "app/utils";
import { configSelector } from "app/redux/slides/config.slide";
import { ShopType } from "app/models/ShopType";
import DragDropZone from "./DragDropZone";

const MAX_PART = 20;
interface DefaultProps {
  cuttingType: CuttingType;
  files: any[];
  project: Project;
  hidden?: boolean;
  onFilesLoaded?: any;
  onAddFiles?: any;
  onNext?: any;
  onGenerateDxf?: any;
}

// eslint-disable-next-line arrow-body-style
const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  // Can not select days before today and today
  return current && current < dayjs().endOf("day");
};

function CalculationStep2(props: DefaultProps) {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const {
    cuttingType,
    files,
    onFilesLoaded,
    onAddFiles,
    onNext,
    onGenerateDxf,
  } = props;
  const opening = useSelector(projectSelector);
  const project: Project = opening.data;
  const partsStatus = opening.partsStatus;
  const uploadFiles = opening.uploadFiles;
  const { t } = useTranslation();
  const [adaptForm] = Form.useForm();
  const [partsUploaded, setPartsUploaded] = useState<Part[]>([]);
  const [cadFiles, setCadFiles] = useState<any[]>([]);
  const [additionFiles, setAdditionFiles] = useState<any[]>([]);
  const [parts, setParts] = useState<Part[]>(project?.parts || []);
  const [error, setError] = useState<any>();
  const [errorMax, setErrorMax] = useState(false);
  const [isOpepUploadParts, setIsOpepUploadParts] = useState(false);
  const [cuttingTypeUpload, setCuttingTypeUpload] = useState(cuttingType);
  const [isOpenOriginalDeliveryDate, setIsOpenOriginalDeliveryDate] =
    useState(false);
  const [adaptDeliveryDate, setAdaptDeliveryDate] = useState(
    project.order.adaptedDeliveryDate || project.order.deliveryDate
  );
  const [loadingAdaptDeliveryDate, setLoadingAdaptDeliveryDate] =
    useState(false);
  const [isOpenMoveCloneParts, setIsOpenMoveCloneParts] = useState(false);
  const [isShowCalculateAll, setIsShowCalculateAll] = useState(
    Object.keys(partsStatus).some(
      (p: any) => partsStatus[p] === PartViewMode.EDIT
    )
  );
  const [partFiles, setPartFiles] = useState<any>();

  const onPartUploadedChange = (part: Part) => {
    if (!part) return;
    const ip = partsUploaded.findIndex((p) => p.id === part.id);
    if (ip > -1) {
      partsUploaded[ip] = { ...part };
    } else {
      partsUploaded.push(part);
    }
    setPartsUploaded([...partsUploaded]);
  };

  const canNext = () => {
    const i = !project.selfCalculation
      ? project.parts?.findIndex((p) => p.auto && !p.totalPrice)
      : project.parts?.findIndex((p) => p.totalPrice === null);
    const pUpload = Object.keys(uploadFiles)?.findIndex(
      (key) => uploadFiles[key] === null
    );
    const isFormValid = !!adaptForm.getFieldValue("deliveryDate");
    if (project.selfCalculation) {
      return isFormValid && i === -1 && pUpload === -1;
    } else return i === -1 && pUpload === -1;
  };

  useEffect(() => {
    if (canNext()) setError(undefined);
  }, [project]);

  const onSubmit = async () => {
    setError(undefined);
    if (!canNext()) {
      adaptForm.validateFields();
      setError(true);
      return;
    }
    if (project.order.adaptedDeliveryDate !== adaptDeliveryDate) {
      await onAdaptDeliveryDate(adaptForm.getFieldsValue());
    }
    if (onNext) onNext();
  };

  useEffect(() => {
    const data = files;
    setAdditionFiles(data);
    return () => {
      setAdditionFiles([]);
      if (onFilesLoaded) onFilesLoaded();
    };
  }, []);

  useEffect(() => {
    if (cadFiles.length > 0) {
      setAdditionFiles([...cadFiles, ...additionFiles]);
      if (onAddFiles) onAddFiles();
    }
  }, [cadFiles]);

  useEffect(() => {
    setIsShowCalculateAll(
      Object.keys(partsStatus).some(
        (p: any) => partsStatus[p] === PartViewMode.EDIT
      )
    );
  }, [partsStatus]);

  const onCadFilesChange = ({ files }: any) => {
    setErrorMax(false);
    onCloseUploadParts();
    const data = files;
    setCadFiles(data);
  };

  const onSubmitForm = (rs: any) => {
    onCloseUploadParts();
    setAdditionFiles([rs, ...additionFiles]);
  };

  const onOpeneUploadParts = () => {
    setIsOpepUploadParts(true);
  };

  const onCloseUploadParts = () => {
    setIsOpepUploadParts(false);
  };

  const onCuttingTypeUploadChange = (value: any) => {
    setCuttingTypeUpload(value);
  };

  const onAdaptDeliveryDate = async (values: any) => {
    setLoadingAdaptDeliveryDate(true);
    try {
      const rs = await projectServices.adaptDeliveryDate({
        projectId: project.id,
        deliveryDate: values.deliveryDate.format("YYYY-MM-DD"),
      });
      dispatch(projectActions.setProject(rs));
      api.info({
        message: `Adapt delivery date`,
        description: (
          <>
            Change delivery date to{" "}
            {moment(values.deliveryDate.format("YYYY-MM-DD")).format("L")}!
          </>
        ),
        placement: "topRight",
      });
    } catch (error) {
      api.error({
        message: `Adapt delivery date`,
        description: <>Failed!</>,
        placement: "topRight",
      });
    }
    setLoadingAdaptDeliveryDate(false);
  };

  const onAdaptDeliveryDateChange = (e: any) => {
    setAdaptDeliveryDate(e.format("YYYY-MM-DD"));
  };

  const onAdaptReset = () => {
    adaptForm.setFieldValue("deliveryDate", dayjs(project.order.deliveryDate));
    setAdaptDeliveryDate(project.order.deliveryDate);
  };

  const onCalculateAll = () => {
    dispatch(projectActions.callCalculateAll(true));
    setTimeout(() => {
      dispatch(projectActions.resetCalculateAll(true));
    }, 300);
  };

  const onOpenMoveCloneParts = (mode: any) => {
    setIsOpenMoveCloneParts(true);
  };

  const RenderCardFileItem = (part: Part) => {
    return (
      <CadFileItem
        key={`part-${part.id}`}
        type={part.cuttingType}
        part={part}
      />
    );
  };

  const RenderAdditionFiles = (item: any) => {
    if (item.partFileName?.length) {
      return RenderCardFileItem(item);
    }

    return (
      <CadFileItem
        key={`${item.cadFile?.uid}`}
        type={cuttingTypeUpload}
        file={item.cadFile}
        pdfFile={item.pdfFile}
        onPartUploadedChange={onPartUploadedChange}
      />
    );
  };

  return (
    <>
      {contextHolder}
      {/* {config.shopType !== ShopType.BOTH && (
        <div className="mb-3">
          <CalculationStep1
            onCuttingTypeChange={onCuttingTypeUploadChange}
            onChange={onCadFilesChange}
            onGenerateDxf={onSubmitForm}
          />
        </div>
      )} */}
      <div className="s2-parts">
        <DragDropZone onSelectedFiles={onCadFilesChange}>
          <div className="d-flex align-items-center mb-3">
            <h6 className="mb-0">{t("parts")}</h6>
            <Button
              className="ms-auto"
              type="primary"
              onClick={onOpeneUploadParts}
            >
              <PlusOutlined /> {t("addPart")}
            </Button>
          </div>
          {errorMax && (
            <Alert
              className="mb-3"
              message={`Max part ${MAX_PART}`}
              type="error"
              showIcon
            />
          )}
          {additionFiles.map((item, index) => {
            return RenderAdditionFiles(item);
          })}
          {parts?.map((item) => RenderCardFileItem(item))}
          {error && (
            <Alert
              message={t("project.error.goToReview")}
              type="error"
              showIcon
            />
          )}
          {project.selfCalculation && (
            <>
              <p className="mt-3 sub-l">{t("project.deliveryDate")}</p>
              <Form
                form={adaptForm}
                initialValues={{
                  projectId: project.id,
                  deliveryDate:
                    project.order?.adaptedDeliveryDate ||
                    project.order?.deliveryDate
                      ? dayjs(
                          project.order?.adaptedDeliveryDate ||
                            project.order?.deliveryDate
                        )
                      : "",
                }}
                onFinish={onAdaptDeliveryDate}
                disabled={loadingAdaptDeliveryDate}
              >
                <Form.Item name="projectId" hidden>
                  <Input />
                </Form.Item>
                <Space.Compact className="mb-3">
                  {!!project.order?.deliveryDate && (
                    <Form.Item className="mb-0">
                      <Button
                        type="default"
                        icon={<UndoOutlined />}
                        disabled={
                          project.order.deliveryDate === adaptDeliveryDate
                        }
                        onClick={onAdaptReset}
                      />
                    </Form.Item>
                  )}
                  <Popover
                    placement="left"
                    content={
                      <>
                        <p className="mb-2 fw-bold">
                          {t("originalDeliveryDate")}
                        </p>
                        {project.order?.deliveryDate &&
                          moment(project.order.deliveryDate).format("L")}
                      </>
                    }
                    trigger="hover"
                    open={isOpenOriginalDeliveryDate}
                  >
                    <Form.Item
                      className="hidden-label"
                      label={t("project.deliveryDate")}
                      name="deliveryDate"
                      rules={[{ required: true }]}
                    >
                      <DatePicker
                        style={{ width: "15vw" }}
                        allowClear={false}
                        onFocus={setIsOpenOriginalDeliveryDate.bind(
                          null,
                          !!project.order?.deliveryDate
                        )}
                        onBlur={setIsOpenOriginalDeliveryDate.bind(null, false)}
                        onChange={onAdaptDeliveryDateChange}
                        disabledDate={disabledDate}
                      />
                    </Form.Item>
                  </Popover>
                  {/* <Form.Item className="mb-0">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loadingAdaptDeliveryDate}
                  icon={<CheckOutlined />}
                  disabled={
                    project.order.adaptedDeliveryDate === adaptDeliveryDate
                  }
                />
              </Form.Item> */}
                </Space.Compact>
              </Form>
            </>
          )}
          <div className="b-container-fixed d-flex justify-content-end">
            {isShowCalculateAll && (project?.parts?.length || 0) > 1 && (
              <Button type="primary" onClick={onCalculateAll}>
                {t("calculation.calculateAll")}
              </Button>
            )}
            <Button
              type="primary"
              onClick={onSubmit}
              className="ms-3"
              disabled={!canNext()}
            >
              {t("calculation.submitToReview")} <ArrowRightOutlined />
            </Button>
          </div>
        </DragDropZone>
      </div>

      <Modal
        open={isOpepUploadParts}
        width={"80vw"}
        footer={null}
        onCancel={onCloseUploadParts}
        destroyOnClose
      >
        <CalculationStep1
          onCuttingTypeChange={onCuttingTypeUploadChange}
          onChange={onCadFilesChange}
          onGenerateDxf={onSubmitForm}
        />
      </Modal>
      {/* <Modal
        open={isOpenMoveCloneParts}
        width={"50vw"}
        footer={null}
        onCancel={setIsOpenMoveCloneParts.bind(null, false)}
      >
        <MoveAndCloneParts mode="MOVE" project={project} />
      </Modal> */}
    </>
  );
}

export default CalculationStep2;
